export * from './lib/components/tone-of-voice-card/tone-of-voice-card.component';
export * from './lib/tone-of-voice.module';
